import { config } from 'enviroment.js'
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Modal, Upload, message, Form, Input, Button, Popconfirm } from 'antd'
import {
  LoadingOutlined,
  PlusOutlined,
  DeleteOutlined,
} from '@ant-design/icons'
import 'antd/dist/antd.css'
import 'Pages/Admin/Admin.scss'
import { getCookie } from 'common/utils/auth'

const headers = {
  'Content-Type': 'application/json',
  Authorization: `Bearer ${getCookie('token')}`,
}

function EditItemModal(props) {
  const {
    visible,
    setVisible,
    activeItem,
    setActiveItem,
    setInventory,
    experienceInfo,
    setLocks,
  } = props
  const [loading, setLoading] = useState(false)
  const [imageSrc, setImageSrc] = useState()
  const [form] = Form.useForm()

  useEffect(() => {
    if (activeItem) {
      form.setFieldsValue({
        itemId: activeItem?.id,
        displayName: activeItem?.displayName,
        internalName: activeItem?.internalName,
      })
      setImageSrc(activeItem?.data?.src)
    }
  }, [form, activeItem])

  const onCancel = () => {
    setVisible(false)
    setActiveItem(null)
    setImageSrc(null)
    form.resetFields()
  }

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  )

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!')
    }
    const isLt3M = file.size / 1024 / 1024 < 3
    if (!isLt3M) {
      message.error('Image must be smaller than 3MB!')
    }
    if (isJpgOrPng && isLt3M) {
      const reader = new FileReader()
      reader.onload = (e) => {
        setImageSrc(e.target.result)
      }
      reader.readAsDataURL(file)
    }
    return false
  }

  const onSubmit = (values) => {
    form
      .validateFields()
      .then((values) => {
        let formData = new FormData()
        formData.append('xExperienceId', activeItem.xExperienceId)
        formData.append('inventoryType', activeItem.inventoryType)
        const path =
          experienceInfo.store
            .trim()
            .toLowerCase()
            .replaceAll(':', '')
            .replaceAll(' ', '-') +
          '/' +
          experienceInfo.name
            .trim()
            .toLowerCase()
            .replaceAll(':', '')
            .replaceAll(' ', '-') +
          '/'
        formData.append('path', path)
        formData.append(
          'filename',
          values.displayName
            .trim()
            .toLowerCase()
            .replaceAll(':', '')
            .replaceAll(' ', '-')
        )
        const itemId = values.itemId
        delete values.itemId
        if (typeof values.image === 'undefined') delete values.image
        for (const [key, value] of Object.entries(values)) {
          formData.append(key, value)
        }

        // Add insert position info if adding before/after
        if (activeItem.actionType === 'add' && activeItem.insertPosition) {
          formData.append('insertPosition', activeItem.insertPosition)
          formData.append(
            'referenceOrderNumber',
            activeItem.referenceOrderNumber
          )
        }

        let url = config.raUrl + `/inventory/${itemId}/`
        let requestType = 'put'
        if (activeItem.actionType === 'add') {
          url = config.raUrl + '/inventory/create/'
          requestType = 'post'
        }
        axios[requestType](url, formData, { headers })
          .then((res) => {
            setVisible(false)
            setActiveItem(null)
            setImageSrc(null)
            form.resetFields()
            activeItem.inventoryType === 1
              ? setInventory(res.data)
              : setLocks(res.data)
            message.success('Item updated!')
          })
          .catch((err) => {
            console.log('error caught: ', err)
            message.error('Something went wrong!')
          })
      })
      .catch((errorInfo) => {
        console.log(errorInfo)
      })
  }

  const submitDelete = () => {
    axios
      .delete(config.raUrl + `/inventory/${activeItem.id}/`, {
        headers,
        data: {
          inventoryType: activeItem.inventoryType,
          xExperienceId: activeItem.xExperienceId,
        },
      })
      .then((res) => {
        setVisible(false)
        setActiveItem(null)
        setImageSrc(null)
        form.resetFields()
        activeItem.inventoryType === 1
          ? setInventory(res.data)
          : setLocks(res.data)
        message.success('Item deleted!')
      })
      .catch((err) => {
        console.log('error caught: ', err)
        message.error('Something went wrong!')
      })
  }

  return (
    <Modal
      title={activeItem?.actionType === 'add' ? 'Add Item' : 'Edit Item'}
      centered
      visible={visible}
      onCancel={onCancel}
      width={500}
      destroyOnClose={true}
      footer={
        activeItem?.actionType === 'add'
          ? [
              <Button key="2" onClick={onCancel}>
                Cancel
              </Button>,
              <Button key="3" type="primary" onClick={onSubmit}>
                Save
              </Button>,
            ]
          : [
              <Popconfirm
                key="1"
                placement="top"
                title="Are you sure?"
                onConfirm={submitDelete}
                okText="Delete"
                cancelText="Cancel"
              >
                <Button danger icon={<DeleteOutlined />} />
              </Popconfirm>,
              <Button key="2" onClick={onCancel}>
                Cancel
              </Button>,
              <Button key="3" type="primary" onClick={onSubmit}>
                Save
              </Button>,
            ]
      }
    >
      <Form name="editItem" layout={'vertical'} autoComplete="off" form={form}>
        <Form.Item name="itemId" noStyle>
          <Input type="hidden" />
        </Form.Item>
        <Form.Item
          name="image"
          valuePropName="file"
          getValueFromEvent={(e) => e.file}
        >
          <Upload
            name="avatar"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            beforeUpload={beforeUpload}
          >
            {imageSrc ? (
              <img src={imageSrc} alt="avatar" style={{ width: '100%' }} />
            ) : (
              uploadButton
            )}
          </Upload>
        </Form.Item>
        <Form.Item
          label="Display Name"
          name="displayName"
          className="inputFormItem"
          rules={[
            {
              required: true,
              message: 'Please input a display name!',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Internal Name"
          name="internalName"
          className="inputFormItem"
          rules={[
            {
              required: true,
              message: 'Please input an internal name!',
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  )
}
export default EditItemModal
